export const EMPLOYEE_ATTACHMENT_RELATED_TYPE = 'App\\Entity\\Core\\Employee';

export const EMPLOYEE_ROLE_OPTIONS = [
  {label: 'Oficial de Compliance', value: 'OFFICER'},
  {label: 'Delegado de Compliance', value: 'OFFICER_DELEGATED'},
  {label: 'Auditor', value: 'AUDITOR'},
  {label: 'Gestor de admisión', value: 'ADMISSIONS_MANAGER'},
  {label: 'Empleado', value: 'EMPLOYEE'},
  {label: 'Colaborador', value: 'COLLABORATOR'}
];
